<template>
  <div class="edit">
    <md-dialog :md-active.sync="showDoneDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">
      <md-dialog-title><md-icon>task_alt</md-icon>Email Sent</md-dialog-title>
      <md-dialog-content>
        <p>
          Signature transaction settigns were submitted correctly and the email
          was sent to the recipients.
        </p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="
            $router.push({
              path: 'trail',
              query: { transactionId: transactionId },
            });
            showDoneDialog = false;
          "
          >Audit trail</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showDoneTemplateDialog">
      <md-dialog-title
        ><md-icon>task_alt</md-icon>Template saved</md-dialog-title
      >
      <md-dialog-content>
        <p>The new template was successfully saved. You can use it now.</p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="
            $router.push({
              path: 'send',
              query: { transactionId: transactionId },
            });
            showDoneDialog = false;
          "
          >Create a transaction</md-button
        >
        <md-button
          class="md-primary"
          @click="
            $router.push({
              path: 'landing',
            });
            showDoneDialog = false;
          "
          >HOME</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <h2 class="tab-title">{{ $t("Edit sign fields in the document") }}</h2>
    <md-progress-spinner
      v-if="loading"
      :md-diameter="100"
      :md-stroke="5"
      md-mode="indeterminate"
      style="
        position: absolute;
        z-index: 5;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    ></md-progress-spinner>
    <button class="send-email-btn" @click="onSumbit()" :disabled="disableSave">
      <!-- <a href="http://localhost:3001/sign/api/send_email">Send Email</a> -->
      <span>{{ $route.query.template ? "Save template" : "Submit" }}</span>
    </button>

    <md-dialog-confirm
      :md-active.sync="confrimEmptySubmit"
      md-title="No fields set in document"
      md-content="Do you want to submit the transaction without adding fields?"

      @md-cancel="confrimEmptySubmit=false"
      @md-confirm="confrimEmptySubmit=false;sendMail();" />

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Field properties</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <md-select
            v-model="recipient"
            name="email"
            id="email"
            placeholder="Recipient who fill"
          >
            <md-option
              v-for="email in emails"
              :value="JSON.stringify(email)"
              v-bind:key="email.email"
              :style="{
                'border-left': '6px solid',
                'border-color': email.color,
              }"
              >{{
                email.name ? email.name + " (" + email.email + ")" : email.email
              }}</md-option
            >
          </md-select>
        </md-field>
        <md-checkbox class="md-primary" v-model="fieldRequired" value="1"
          >Required</md-checkbox
        >

        <md-select v-if="isSignFieldType" v-model="signMethodsSelected" multiple required>
              <md-option v-for="(method) in ['Draw','Text','Picture','Mobile']" v-bind:key="method" :value="method">
                {{ method }}
              </md-option>
            </md-select>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showDialog = false">Cancel</md-button>
        <md-button :disabled="!recipient " class="md-primary" @click="!editedField?doAddField():doEditField()"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-speed-dial
    v-if="!appliedTemplate"
      class="md-bottom-right"
      md-event="click"
      style="align-items: flex-end; position: fixed; z-index: 2"
    >
      <md-speed-dial-target class="md-primary">
        <md-icon class="md-morph-initial">add</md-icon>
        <md-icon class="md-morph-final">close</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="dialbtn" @click="addField('date')">
          <div style="color:grey; background:white; border-color:white; width: 124px; height: 24px;"><span style="margin-right: 10px;float: left;"> <md-icon style="margin: auto 0;">event</md-icon></span> <span style="float: left; margin-top: 3px;">DATE</span></div>

        </md-button>
        <md-button class="dialbtn" @click="addField('sign')">
          <div style="color:grey; background:white; border-color:white; width: 124px; height: 24px;"><span style="margin-right: 10px;float: left;"> <md-icon style="margin: auto 0;">create</md-icon></span> <span style="float: left; margin-top: 3px;">SIGN</span></div>

        </md-button>
        <md-button class="dialbtn" @click="addField('text')">
          <div style="color:grey; background:white; border-color:white; width: 124px; height: 24px;"><span style="margin-right: 10px;float: left;"> <md-icon style="margin: auto 0;">format_color_text</md-icon></span> <span style="float: left; margin-top: 3px;">TEXT</span></div>

        </md-button>
        <md-button class="dialbtn" @click="addField('check')">
          <div style="color:grey; background:white; border-color:white; width: 124px; height: 24px;"><span style="margin-right: 10px;float: left;"> <md-icon style="margin: auto 0;">check_box_outline_blank</md-icon></span> <span style="float: left; margin-top: 3px;">CHECKBOX</span></div>

        </md-button>

        <!-- <md-button @click="addField('radio')">
          <div style="color:grey; width: 124px; height: 24px;"><span style="margin-right: 10px;float: left;"> <md-icon style="margin: auto 0;">radio_button_checked</md-icon></span> <span style="float: left; margin-top: 3px;">RADIO</span></div>

        </md-button> -->

        <!-- <md-button @click="addField('new')">
          <div style="color:grey; width: 124px; height: 24px;"><span style="margin-right: 10px;float: left;"> <md-icon style="margin: auto 0;">create</md-icon></span> <span style="float: left; margin-top: 3px;">NEW FIELD</span></div>

        </md-button> -->
      </md-speed-dial-content>
    </md-speed-dial>
    <!-- <pdf
        ref="pdfViewer"
        id="pdf-viewer"
        :src="src || '/test.pdf'"
        :page="currentPage"
        @num-pages="pageCount = $event"
        @page-loaded="pageLoaded($event)"
      >
        loading...
      </pdf> -->
    <div class="pdf-pagination" style="height: 45px">
      <div
        row
        wrap
        style="
          display: flex;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        "
      >
        <md-button
          class="md-icon-button md-raised"
          :disabled="noPrevPage"
          @click="prevPage"
        >
          <md-icon>navigate_before</md-icon>
        </md-button>
        <!-- <md-button class="md-raised">First</md-button> -->

        <div xs8 style="margin-top: 10px">
          {{ currentPage }} / {{ pageCount }}
        </div>

        <!-- <md-button class="md-raised">Last</md-button> -->
        <md-button
          class="md-icon-button md-raised"
          :disabled="noNextPage"
          @click="nextPage"
        >
          <md-icon>navigate_next</md-icon>
        </md-button>
        <div style="transform: translate(20px, -6px)">
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            @click="()=>{
let step = pageZoom%0.25 ==0?0.25:(pageZoom%0.25).toFixed(2);
 return pageZoom-step<0.25?pageZoom=0.25: pageZoom-= step;
            }"
            :disabled="pageZoom<=0.25"
          >
            <md-icon>zoom_out</md-icon>
          </md-button>
          <md-input type="number" step="25" min="50" max="200" style="width: 50px;
    text-align: right;
    margin-top: 17px;
    border: 1px solid #cec3c3;
    border-radius: 3px;" v-model="pageZoomAux" @blur.native="pageZoomValidate"  @input.native="pageZoomInput" @keyup.enter="pageZoomValidate"></md-input>
         
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            :disabled="pageZoom>=2"
            @click="()=>{
let step = 0.25 - (pageZoom%0.25).toFixed(2);
 return pageZoom+step>2?pageZoom=2: pageZoom+= step;
 
            }"
          >
            <md-icon>zoom_in</md-icon>
          </md-button>
        </div>
      </div>
    </div>
    <div class="pdf-image-flieds-container" :style="'zoom:' + pageZoom">
      <div style="position: relative">
        <div>
          <img
            id="pdf-image"
            :src="pages[currentPage - 1]"
            alt=""
            :onload="onLoadImg()"
            style="position: absolute; left: 50%; transform: translateX(-50%);  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;"
          />
        </div>
      </div>
      <div style="position: relative; width: 100%">
        <div style="position: absolute; left: 50%; transform: translateX(-50%)">
          <div
            id="fields-cont"
            :style="'position: relative;' + (hideFields ? 'opacity:0;' : '')"
          >
            <component
              v-for="field in fields"
              :style="
                shownFields.indexOf(field) == -1
                  ? 'display:none!important;'
                  : ''
              "
              :is="field"
              :key="field.tmpId"
              :ref="field.tmpId"
            ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import pdf from "vue-pdf";
// import SignaturePad from "signature_pad";
import VueDragResize from "vue-drag-resize";
import DragResizeField from "@/components/DragResizeField.vue";
import axios from "axios";
// var initDocHeight;
export default {
  name: "Edit",
  components: {
    pdf,
    VueDragResize,
    DragResizeField,
  },
  created(){
    const vm = this;
    vm.appliedTemplate=localStorage.getItem('appliedTemplate') =='true';
  },
  mounted() {
    const vm = this;
    this.transactionId =
      localStorage.getItem("transactionId") || vm.$route.query.transactionId;

    if (vm.$route.query.template) {
      vm.emails = JSON.parse(localStorage.getItem("recipients"));
      for (let index = 0; index < vm.emails.length; index++) {
        vm.emails[index].color = vm.colors.shift();
      }

      let templateFields=JSON.parse(localStorage.getItem(
                "templateFields"));

                for (let index = 0; index < templateFields.length; index++) {
           // vm.buildTemplateField(templateFields[index]);
            vm.buildField(templateFields[index]);
          }

      axios({
        method: "post",
        url: "/sign/getDocument",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          docId: vm.$route.query.file,
        },
      })
        .then((response) => {
          console.log(" docSUCCESS!!");
          console.log(response);
          vm.pages = response.data.pages;
          vm.pageCount = vm.pages.length;
          vm.currentPageImg = response.data.pages[0];
        })
        .catch(function () {
          console.log(" doc FAILURE!!");
        });
    } else {
      axios({
        method: "get",
        url: "/sign/transaction",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: vm.transactionId,
        },
      })
        .then((response) => {
          vm.transactionData = response.data;
          vm.sign_document = response.data.sign_document;
          vm.emails = response.data.names;
          vm.appliedTemplate = !!response.data.templateId;

          for (let index = 0; index < response.data.fields.length; index++) {
            vm.buildField(response.data.fields[index]);
            // vm.doAddField('sign');
          }

          if (vm.$route.query.template) {
            vm.emails = JSON.parse(localStorage.getItem("recipients"));
          }

          for (let index = 0; index < vm.emails.length; index++) {
            vm.emails[index].color = vm.colors.shift();
          }
          axios({
            method: "post",
            url: "/sign/getDocument",
            baseURL: process.env.VUE_APP_BASE_API,
            headers: {
              Authorization:
                "Bearer " + Vue.prototype.$userData.tokens.access.token,
            },
            data: {
              docId: vm.sign_document,
            },
          })
            .then((response) => {
              console.log(" docSUCCESS!!");
              console.log(response);
              vm.pages = response.data.pages;
              vm.pageCount = vm.pages.length;
              vm.currentPageImg = response.data.pages[0];
            })
            .catch(function () {
              console.log(" doc FAILURE!!");
            });
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    }

    // this.emails = JSON.parse(localStorage.getItem("recipients"));

    var pdfFile = localStorage.getItem("pdfFile");
    function convertDataURIToBinary(dataURI) {
      var BASE64_MARKER = ";base64,";
      var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      var base64 = dataURI.substring(base64Index);
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));

      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    }

    this.src = convertDataURIToBinary(pdfFile);

    window.initDocHeight = (
      document.querySelector("#pdf-viewer") ||
      document.querySelector("#pdf-image")
    ).offsetHeight;
    window.initDocWidth = (
      document.querySelector("#pdf-viewer") ||
      document.querySelector("#pdf-image")
    ).offsetWidth;

    function reportWindowSize() {
      // var imgPdf = document.getElementById("pdf-image");
      // var fieldsCont = document.getElementById("fields-cont");
      // fieldsCont.style.height = imgPdf.offsetHeight + "px";
      // fieldsCont.style.width = imgPdf.width + "px";
      // var newDocHeight = (document.querySelector("#pdf-viewer")||document.querySelector("#pdf-image")).offsetHeight;
      // var newDocWidth = (document.querySelector("#pdf-viewer")||document.querySelector("#pdf-image")).offsetWidth;
      // var zoom;
      // if (window.initDocWidth < newDocWidth) {
      //   zoom = newDocHeight / window.initDocHeight;
      //   if (zoom * window.initDocWidth > newDocWidth) {
      //     zoom = newDocWidth / window.initDocWidth;
      //   }
      // } else {
      //   zoom = newDocWidth / window.initDocWidth;
      //   if (zoom * window.initDocHeight > newDocHeight) {
      //     zoom = newDocHeight / window.initDocHeight;
      //   }
      // }
      // var scale= newDocHeight / window.initDocHeight;
      //document.getElementById("fields-cont").style.zoom = zoom * 0.95;
      // console.log(newDocHeight);
      // window.initDocHeigh=newDocHeight;
    }

    window.onresize = reportWindowSize;

    /************ Create component programaticlly *******************/
    // var cont = new VueDragResize({
    //     propsData: { style: 'background:white;' }
    // });
    // console.log('aaa');
    // console.log(cont);

    // cont.$mount() // pass nothing
    // this.$refs.pdfViewer.appendChild(cont.$el)

    // const ComponentCtor = Vue.extend(VueDragResize);
    // const componentInstance = new ComponentCtor({
    //   propsData: { style: "background:white;" },
    // });
    // componentInstance.$mount();
    // console.log("new component aaaa");
    // console.log(componentInstance.$el);
    // document.getElementById("fields-cont").appendChild(componentInstance.$el);

    /***********************************************************************/

    // const container = document.querySelector("span#pdf-viewer");

    // var input = document.createElement("input");
    // input.type = "text";
    // input.style =
    //   "width: 49.1%; height: 3.5%;z-index: 2; position: absolute; left: 25%; top: 60.5%;";
    // container.appendChild(input);

    // input = document.createElement("input");
    // input.type = "date";
    // input.style =
    //   "width: 49.1%; height: 3.5%;z-index: 2; position: absolute; left: 25%; top: 64.1%;";
    // container.appendChild(input);

    // input = document.createElement("input");
    // input.type = "date";
    // input.style =
    //   "width: 49.1%; height: 3.5%;z-index: 2; position: absolute; left: 25%; top: 78.1%;";
    // container.appendChild(input);

    // var signSpan = document.createElement("span");
    // signSpan.style =
    //   "border: 1px solid;width: 49.1%; height: 8.5%;z-index: 2; position: absolute; left: 25%; top: 69.4%; overflow:hidden;";
    // var signCanvas = document.createElement("canvas");
    // signCanvas.id = "signature-pad";
    // signCanvas.width = 1000;
    // signCanvas.height = 1000;
    // signCanvas.style = "max-width:unset;";
    // signSpan.appendChild(signCanvas);

    // container.appendChild(signSpan);

    // function resizeCanvas() {
    //     // When zoomed out to less than 100%, for some very strange reason,
    //     // some browsers report devicePixelRatio as less than 1
    //     // and only part of the canvas is cleared then.
    //     var ratio =  Math.max(window.devicePixelRatio || 1, 1);
    //     signCanvas.width = signCanvas.offsetWidth * ratio;
    //     signCanvas.height = signCanvas.offsetHeight * ratio;
    //     signCanvas.getContext("2d").scale(ratio, ratio);

    // }

    // window.onresize = resizeCanvas;
    // resizeCanvas();

    // new SignaturePad(signCanvas);
  },
  data() {
    return this.initialData();
  },
  computed: {
    disableSave() {
      return !!document.querySelector(".overlap");
    },
    noPrevPage() {
      return this.currentPage <= 1;
    },
    noNextPage() {
      return this.currentPage === this.pageCount;
    },
  },
  watch: {
    pageZoom: function (newVal) {
      this.pageZoomAux=Math.round(newVal*100);

     
    },
  },
  methods: {
    pageZoomInput(event){
            if (!event.inputType||event.inputType === "increment" || event.inputType === "decrement") {
  this.pageZoomValidate();
}
    },
    pageZoomValidate() {
const vm =this;
let validZoom= false;
const newVal=vm.pageZoomAux/100;
if(newVal>2){
      vm.pageZoom=2;
     }else  if(newVal<0.25){
      vm.pageZoom=0.25;
     }else{
      validZoom= true;
      vm.pageZoom=Number(newVal);
     }

     if(!validZoom){
      Vue.$toast.open({
              message: "The zoom value must be between 25% and 200%",
              position: "bottom",
              type: "default",
            });
     }
     
    },
    initialData() {
      return {
      editedField: null,
      confrimEmptySubmit:false,
        appliedTemplate:false,
        fieldRequired: "1",
        pageZoom: 1,
        pageZoomAux: 100,
        loading: false,
        hideFields: false,
        pages: [],
        transactionData: {},
        sign_document: "",
        currentPageImg: "",
        showDoneDialog: false,
        showDoneTemplateDialog: false,
        transactionId: null,
        currentPage: 1,
        pageCount: 0,
        src: null,
        zoom: 100,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        numberRadio: 2,
        fields: [],
        shownFields: [],
        emails: [],
        signMethodsSelected:['Draw','Text','Picture','Mobile'],
        showDialog: false,
        isSignFieldType: false,
        newFieldType: "",
        recipient: "",
        colors: [
          "#7CB9E8",
          "#9966CC",
          "#E52B50",
          "#F19CBB",
          "#3B7A57",
          "#FFBF00",
          "#FF7E00",
          "#841B2D",
          "#008000",
          "#007FFF",
          "#87421F",
        ],
      };
    },
    onLoadImg() {
      setTimeout(function () {
        var imgPdf = document.getElementById("pdf-image");
        var fieldsCont = document.getElementById("fields-cont");
        fieldsCont.style.height = imgPdf.offsetHeight + "px";
        fieldsCont.style.width = imgPdf.width + "px";
      }, 0);
    },
    prevPage() {
      this.currentPage--;
      this.updateFields();
    },
    nextPage() {
      this.currentPage++;
      this.updateFields();
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    pageLoaded(event) {
      this.currentPage = event;
      window.initDocHeight = (
        document.querySelector("#pdf-viewer") ||
        document.querySelector("#pdf-image")
      ).offsetHeight;
      console.log("pageloaded");
      console.log(window.initDocHeight);
    },
    openFieldDialog(type) {
      const vm =this;
      localStorage.setItem('currentFieldType', type);
   vm.isSignFieldType= type=='sign';
      if(!this.editedField){
this.fieldRequired='1';
        this.numberRadio=2;
        this.recipient='';
        this.signMethodsSelected=['Draw','Text','Picture','Mobile'];
      }
      setTimeout(()=>{
       
        vm.showDialog = true;
      },0)
     
    },
    addField(type) {

        this.editedField=null;
      this.openFieldDialog(type);
    },
    buildTemplateField(fieldData) {
      console.log('aaaaaa');
      console.log(fieldData);

      const fieldType =  fieldData.type || "sign";
      var vm = this;     
      var fields = vm.fields;
      const tmpFieldId = fieldData._id;
      const recEmail=fieldData.owner;
      const req = !!fieldData.required;
      const singOpts =fieldData.signMethods;
      setTimeout(()=>{
        console.log('bbbbbb');
        fields.push({
        render(h) {
          return h(DragResizeField, {
            class: ["foo"],
            template: "<span>holi</span>",
            on: {
              remove: function (field) {
          
                field.$destroy();

                // remove the element from the DOM
                field.$el.parentNode.removeChild(field.$el);
              },
              settings: function(field){
                console.warn('settings');
                vm.editedField=field;
                vm.signMethodsSelected=field.signMethods;
vm.numberRadio=field.numberRadio;
vm.fieldRequired=field.isRequired?'1':'0';
vm.recipient=JSON.stringify(vm.emails.find((el) => el.email == field.email));
                vm.openFieldDialog(field.type);
              }
            },
            props: {
              recipient: JSON.parse(
                JSON.stringify({
                  email: recEmail,
                  color: vm.emails.find((el) => el.email == recEmail)
                    .color,
                })
              ),
              tmpId: tmpFieldId,
              required: req,
              name: tmpFieldId,
              isActive: true,
              type: fieldType,
              index: fields.length - 1,
              page: fieldData.page,
              signMethods:JSON.parse(singOpts),

              height: fieldData.height,
              width: fieldData.width,
              top: fieldData.top,
              left: fieldData.left,
            },
          });
        },
      });

      fields[fields.length - 1].page = fieldData.page;
      fields[fields.length - 1].tmpId = tmpFieldId;
      console.log(fields);
       vm.recipient='';
       vm.fieldRequired='1';
      vm.updateFields();
      },0)

    },
    buildField(fieldData) {
      var vm = this;
      var fields = vm.fields;
      console.log('fieldData')
      console.log(fieldData)
      fields.push({
        render(h) {
          return h(DragResizeField, {
            class: ["foo"],
            template: "<span>holi</span>",
            on: {
              remove: function (field) {
                console.log(fields);
                console.log(field);
                field.$destroy();

                // remove the element from the DOM
                field.$el.parentNode.removeChild(field.$el);
              },
              settings: function(field){
                console.warn('settings');
                vm.editedField=field;
                vm.signMethodsSelected=field.signMethods;
vm.numberRadio=field.numberRadio;
vm.fieldRequired=field.isRequired?'1':'0';
vm.recipient=JSON.stringify(vm.emails.find((el) => el.email == field.email));
                vm.openFieldDialog(field.type);
              }
   
            },
            props: {
              recipient: JSON.parse(
                JSON.stringify({
                  email: fieldData.owner,
                  color: vm.emails.find((el) => el.email == fieldData.owner)
                    .color,
                })
              ),
              required: fieldData.required || false,
              tmpId: fieldData._id,
              name: "Foo",
              isActive: true,
              type: fieldData.type || "sign",
              index: fields.length - 1,
              page: fieldData.page,
              height: fieldData.height,
              width: fieldData.width,
              top: fieldData.top,
              left: fieldData.left,
              signMethods:fieldData.signMethods || [],
              fixed: true,
            },
          });
        },
      });

      fields[fields.length - 1].page = fieldData.page;
      fields[fields.length - 1].tmpId = fieldData._id;
      console.log('fields:');
      console.log(fields);
      setTimeout(function () {
        vm.updateFields();
      }, 0);
    },
    doEditField(){
const vm=this;
const field= vm.editedField;
field.signMethods=vm.signMethodsSelected;
field.methods=vm.signMethodsSelected;

field.numberRadio=vm.numberRadio;
field.radioOptions=vm.numberRadio;

field.isRequired=vm.fieldRequired=='1';
field.required=vm.fieldRequired=='1';

field.recipient=JSON.parse(vm.recipient);
field.email=field.recipient.email;
field.color=field.recipient.color;
vm.showDialog = false;
    },
    doAddField() {
      const fieldType =  localStorage.getItem('currentFieldType');
      var vm = this;     
      var fields = vm.fields;
      vm.showDialog = false;
      const tmpFieldId = Date.now().toString();
      console.log('-------------- EMAILS ---------');
      console.log(vm.emails)
      console.log(vm.recipient)
      let obj = JSON.parse(vm.recipient);
      const recEmail=obj.email;
      const req = vm.fieldRequired == "1";
      const singOpts =JSON.stringify(vm.signMethodsSelected);
      setTimeout(()=>{
        fields.push({
        render(h) {
          return h(DragResizeField, {
            class: ["foo"],
            template: "<span>holi</span>",
            on: {
              remove: function (field) {
                console.log(fields);
                console.log(field);
                field.$destroy();

                // remove the element from the DOM
                field.$el.parentNode.removeChild(field.$el);
              },
              settings: function(field){
                console.warn('settings');
                vm.editedField=field;
                vm.signMethodsSelected=field.signMethods;
vm.numberRadio=field.numberRadio;
vm.fieldRequired=field.isRequired?'1':'0';
vm.recipient=JSON.stringify(vm.emails.find((el) => el.email == field.email));
                vm.openFieldDialog(field.type);
              }
            },
            props: {
              recipient: JSON.parse(
                JSON.stringify({
                  email: recEmail,
                  color: vm.emails.find((el) => el.email == recEmail)
                    .color,
                })
              ),
              tmpId: tmpFieldId,
              required: req,
              name: tmpFieldId,
              isActive: true,
              type: fieldType,
              index: fields.length - 1,
              page: vm.currentPage,
              numberRadio: vm.numberRadio,
              height: undefined,
              width: fieldType=='check'?110:undefined,
              signMethods:JSON.parse(singOpts),
              disableDelete: vm.appliedTemplate
            },
          });
        },
      });

      fields[fields.length - 1].page = vm.currentPage;
      fields[fields.length - 1].tmpId = tmpFieldId;
      console.log(fields);
       vm.recipient='';
       vm.fieldRequired='1';
      vm.updateFields();
      },0)

    },

    updateFields() {
      var vm = this;

      this.shownFields = this.fields.filter(function (el) {
        return el.page == vm.currentPage;
      });
      console.log(this.hideFields);
      console.log(this.shownFields);
    },
    onSumbit(){
      const vm =this;
if(vm.fields && vm.fields.length){

  vm.sendMail();
}else{
  vm.confrimEmptySubmit=true; 
}
    },
    sendMail() {
      const vm = this;

      delete vm.transactionData.id;
      this.hideFields = true;
      this.loading = true;
      this.shownFields = this.fields;
      setTimeout(function () {
        var fieldElements = Array.prototype.slice
          .call(document.getElementById("fields-cont").children)
          .map((field) => {
            return {
              owner: field.querySelector("#email-data").innerText, //owner
              type: field.querySelector("#type-data").innerText,
              required:
                field.querySelector("#required-data").innerText == "true",
              page: field.querySelector("#page-data").innerText,
              signMethods: (field.querySelector("#sign-methods").innerText||'').split(','),
              top: field.offsetTop,
              left: field.offsetLeft,
              width: field.offsetWidth,
              height: field.offsetHeight,
            };
          });

        if (vm.$route.query.template) {
          axios({
            method: "put",
            url: "/template/template",
            baseURL: process.env.VUE_APP_BASE_API,
            headers: {
              Authorization:
                "Bearer " + Vue.prototype.$userData.tokens.access.token,
            },
            params: {
              templateId: vm.$route.query.template,
            },
            data: {
              fields: fieldElements,
            },
          })
            .then(() => {
              console.log("put SUCCESS!!");
              //  vm.$router.push({
              //             path: "send",
              //           });
              vm.loading = false;
              vm.showDoneTemplateDialog = true;
            })
            .catch(function () {
              console.log("put FAILURE!!");
              vm.loading = false;
            });
        } else {
      

            vm.transactionData.fields = !vm.appliedTemplate?fieldElements:vm.transactionData.fields.map((el)=>{ delete el._id; return el;});
          

          for (
            let index = 0;
            index < vm.transactionData.names.length;
            index++
          ) {
            delete vm.transactionData.names[index].color;
            delete vm.transactionData.names[index]._id;
          }

          delete vm.transactionData._id;
          delete vm.transactionData.__v;
          delete vm.transactionData.createdAt;
          delete vm.transactionData.updatedAt;
          delete vm.transactionData.refEmail;
          axios({
            method: "put",
            url: "/sign/transaction",
            baseURL: process.env.VUE_APP_BASE_API,
            headers: {
              Authorization:
                "Bearer " + Vue.prototype.$userData.tokens.access.token,
            },
            params: {
              transactionId: vm.transactionId,
            },
            data: vm.transactionData,
          })
            .then(() => {
              console.log("put SUCCESS!!");

              axios({
                method: "post",
                url: "/sign/send",
                baseURL: process.env.VUE_APP_BASE_API,
                headers: {
                  Authorization:
                    "Bearer " + Vue.prototype.$userData.tokens.access.token,
                },
                params: {
                  transactionId: vm.transactionId,
                },
              })
                .then(() => {
                  console.log("SUCCESS!!");
                  vm.showDoneDialog = true;
                  vm.loading = false;
                })
                .catch(function () {
                  console.log("FAILURE!!");
                });
            })
            .catch(function () {
              console.log("put FAILURE!!");
              vm.loading = false;
            });
        }
      }, 0);
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.initialData());
  },
};
</script>

<style scoped>
.tab-title {
  color: #a5a5a5;
  margin-bottom: 30px;
}
.edit {
  margin: 10px;
}

.send-email-btn {
  margin: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  overflow: hidden;
  outline: none;
  background: transparent;
  border: 0;
  border-radius: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
  line-height: normal;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  min-width: 120px;
  height: 36px;
  margin: 6px 8px;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  top: 80px;
  right: 80px;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-primary, #fff);
  background-color: #e94e1b;
  position: absolute;
}
.send-email-btn:disabled{
    background-color: #dcdcdc !important;
    cursor: default !important;
    box-shadow: none;
}

.send-email-btn a,
.send-email-btn span {
  color: white !important;
  font-weight: bold !important;
}

.md-button-content .md-checkbox {
  width: 150px;
}

.md-button-content input {
  width: 130px;
}

label,
.md-checkbox-label {
  text-transform: none !important;
}

.dialbtn.md-button.md-theme-default.md-raised:not([disabled]){
  background-color: white!important;
}
</style>